import { PropsWithChildren } from 'react';
import classNames from 'classnames';
import * as styles from './TextButton.module.scss';

type Props = {
  color?: 'green';
  className?: string;
  onClick?: (event?: React.MouseEvent) => void;
  testId?: string;
};

export default function TextButton({ className, children, color, onClick, testId }: PropsWithChildren<Props>) {
  const colorClassName = color && styles[color];
  return (
    <button data-testid={testId} className={classNames(styles.button, className, colorClassName)} onClick={onClick} type="button">
      {children}
    </button>
  );
}
